// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__mc-title{width:1000px}.order-row{width:100%}.detail-title{opacity:.7}.text__price{text:primary}.text-footer th{border-bottom:0}.item_table.table td,.item_table.table th{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.order__status{width:100%;max-width:-webkit-fit-content;max-width:-moz-fit-content;max-width:fit-content;height:auto}.order__status .order__status-text{white-space:break-spaces}", ""]);
// Exports
module.exports = exports;
